const hosts = {
  dev: {
    US: "dev-us.therabody.com",
    default: "dev-us.therabody.com",
  },
  stage: {
    US: "qa-us.therabody.com",
    CA: "qa-ca.therabody.com",
    GB: "qa-uk.therabody.com",
    GG: "qa-uk.therabody.com",
    JE: "qa-uk.therabody.com",
    AU: "qa-au.therabody.com",
    NZ: "qa-nz.therabody.com",
    default: "qa-eu.therabody.com",
  },
  prod: {
    US: "www.therabody.com",
    CA: "www.therabody.ca",
    GB: "www.therabody.co.uk",
    GG: "www.therabody.co.uk",
    JE: "www.therabody.co.uk",
    AU: "www.therabody.com.au",
    NZ: "www.therabody.co.nz",
    default: "www.therabody.eu",
  },
};

const paths = {
  en: {
    AU: "/account/login",
    NZ: "/account/login",
    CA: "/account/login",
    US: "/account/login",
    BE: "/en-bn/account/login?{country}",
    NL: "/en-bn/account/login?{country}",
    FR: "/en-fr/account/login",
    DE: "/en/account/login",
    IE: "/en-ie/account/login",
    IT: "/en-it/account/login",
    ES: "/en-es/account/login",
    CH: "/en-ch/account/login",
    GB: "/account/login",
    GG: "/en-ci/account/login?{country}",
    JE: "/en-ci/account/login?{country}",
    IM: "/en-im/account/login",
    default: "/en-eu/account/login?{country}",
  },
  es: {
    ES: "/es-es/account/login",
    BE: "/es-bn/account/login?{country}",
    NL: "/es-bn/account/login?{country}",
    CH: "/es-ch/account/login",
    default: "/es-eu/account/login?{country}",
  },
  fr: {
    CA: "/fr/account/login",
    FR: "/fr-fr/account/login",
    BE: "/fr-bn/account/login?{country}",
    NL: "/fr-bn/account/login?{country}",
    CH: "/fr-ch/account/login",
    default: "/fr-eu/account/login?{country}",
  },
  de: {
    DE: "/account/login",
    BE: "/de-bn/account/login?{country}",
    NL: "/de-bn/account/login?{country}",
    CH: "/de-ch/account/login",
    default: "/de-eu/account/login?{country}",
  },
  it: {
    IT: "/it-it/account/login",
    BE: "/it-bn/account/login?{country}",
    NL: "/it-bn/account/login?{country}",
    CH: "/it-ch/account/login",
    default: "/it-eu/account/login?{country}",
  },
  default: {
    default: "/account/login",
  },
};

const siteURL = () => {
  const env = process.env.REACT_APP_ENVIRONMENT || "prod"; // dev | stage | prod
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let { debug = "", locale = "" } = Object.fromEntries(urlParams);
  if (!locale) {
    console.warn("Locale not provided, defaulting to 'en-US'");
    locale = "en-US"; // Default locale
  }
  const lang = locale.split("-")?.[0] || "en";
  const country = locale.split("-")?.[1] || "US";
  if (debug) {
    console.debug("siteURL debug:", JSON.stringify({ lang, country }));
  }

  const currentEnvHosts = hosts[env] || hosts.prod; // Default to prod if env is not found
  const host =
    currentEnvHosts[country] || currentEnvHosts.default || "www.therabody.com";

  const currentLangPaths = paths[lang] || paths.default;
  let path = "/account/login";
  if (env !== "dev") {
    path = currentLangPaths[country] || currentLangPaths.default;
    path = path.replace("{country}", "country=" + country);
  }
  const qsLink = path.includes("?") ? "&" : "?";

  return `https://${host}${path}${qsLink}confirmation`;
};

export default siteURL;
